import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


// Global error handlers to prevent unhandled extension/browser metrics loop errors
const shouldSuppressError = (msg) => {
  if (!msg || typeof msg !== 'string') return false;
  return (
    msg.includes("ResizeObserver loop") ||
    msg.includes("startTime") ||
    msg.includes("reportAllChanges")
  );
};

window.addEventListener("error", (e) => {
  if (shouldSuppressError(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

window.addEventListener("unhandledrejection", (e) => {
  const msg = e.reason?.message || String(e.reason);
  if (shouldSuppressError(msg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
